(function () {
    document.addEventListener('DOMContentLoaded', function () {
        var container = document.getElementById('toc-container');
        var list = document.getElementById('toc-list');
        var desktopContainer = document.getElementById('toc-desktop-container');
        var desktopList = document.getElementById('toc-desktop-list');
        var prose = document.querySelector('.prose-mag');
        
        // We need prose and at least one container to exist
        if (!prose || (!container && !desktopContainer)) return;

        var headings = prose.querySelectorAll('h2, h3');
        
        // If there are less than 2 headings, hide the TOC containers and dynamically hide empty sidebar
        if (headings.length < 2) {
            if (container) container.classList.add('hidden');
            if (desktopContainer) desktopContainer.classList.add('hidden');
            adjustLayoutForEmptySidebar(headings);
            return;
        }

        if (container) container.classList.remove('hidden');
        if (desktopContainer) desktopContainer.classList.remove('hidden');

        var headingData = []; // Store heading element and its associated links (mobile and desktop)

        headings.forEach(function (heading, index) {
            // Ensure heading has an ID
            if (!heading.id) {
                heading.id = 'heading-' + index;
            }

            var links = [];

            // Mobile TOC link creation
            if (list) {
                var li = document.createElement('li');
                li.className = heading.tagName.toLowerCase() === 'h3' ? 'pl-4 opacity-80' : 'font-semibold';
                var a = document.createElement('a');
                a.href = '#' + heading.id;
                a.textContent = heading.textContent.replace('¶', '').trim();
                a.className = 'toc-link block py-1 hover:text-[var(--accent)] transition-colors duration-150 text-stone-600 dark:text-stone-400 no-underline';
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    smoothScrollTo(heading);
                });
                li.appendChild(a);
                list.appendChild(li);
                links.push(a);
            }

            // Desktop TOC link creation
            if (desktopList) {
                var liD = document.createElement('li');
                liD.className = heading.tagName.toLowerCase() === 'h3' ? 'pl-4 opacity-80' : 'font-semibold';
                var aD = document.createElement('a');
                aD.href = '#' + heading.id;
                aD.textContent = heading.textContent.replace('¶', '').trim();
                aD.className = 'toc-link block py-1 hover:text-[var(--accent)] transition-colors duration-150 text-stone-600 dark:text-stone-400 no-underline';
                aD.addEventListener('click', function (e) {
                    e.preventDefault();
                    smoothScrollTo(heading);
                });
                liD.appendChild(aD);
                desktopList.appendChild(liD);
                links.push(aD);
            }

            headingData.push({ heading: heading, links: links });
        });

        function smoothScrollTo(headingElement) {
            var offset = 90; // offset height for sticky header (e.g. 64px header + some padding)
            var elementPosition = headingElement.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.scrollY - offset;
            
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }

        // Dynamic layout adjust if sidebar is completely empty (no headings, no author, no tags)
        adjustLayoutForEmptySidebar(headings);

        // Scrollspy logic
        function updateActiveLink() {
            var scrollPosition = window.scrollY + 120; // offset for sticky headers
            
            var activeIndex = -1;
            for (var i = 0; i < headingData.length; i++) {
                if (headingData[i].heading.offsetTop <= scrollPosition) {
                    activeIndex = i;
                } else {
                    break;
                }
            }

            headingData.forEach(function (item) {
                item.links.forEach(function (link) {
                    link.classList.remove('text-[var(--accent)]', 'font-bold');
                    link.classList.add('text-stone-600', 'dark:text-stone-400');
                });
            });

            if (activeIndex !== -1) {
                var activeItem = headingData[activeIndex];
                activeItem.links.forEach(function (link) {
                    link.classList.add('text-[var(--accent)]', 'font-bold');
                    link.classList.remove('text-stone-600', 'dark:text-stone-400');
                });
            }
        }

        window.addEventListener('scroll', updateActiveLink);
        updateActiveLink(); // Initial check

        function adjustLayoutForEmptySidebar(headingsList) {
            var sidebar = document.querySelector('.post-sidebar');
            var mainCol = document.querySelector('.post-main-col');
            var bodyWrapper = document.querySelector('.post-body-wrapper');
            
            if (sidebar && mainCol && bodyWrapper) {
                var hasVisibleChildren = false;
                
                // 1. TOC is active if headings count >= 2
                if (headingsList.length >= 2) {
                    hasVisibleChildren = true;
                }
                
                // 2. Author card block is active if present
                var authorCards = sidebar.querySelectorAll('.author-sidebar-wrapper');
                if (authorCards.length > 0) {
                    hasVisibleChildren = true;
                }
                
                // 3. Tags block is active if present
                var tagsCard = sidebar.querySelector('.sidebar-tags-card');
                if (tagsCard) {
                    hasVisibleChildren = true;
                }
                
                if (!hasVisibleChildren) {
                    sidebar.classList.add('hidden');
                    
                    // Revert post-default column sizing and centering
                    if (mainCol.classList.contains('lg:max-w-[56rem]')) {
                        mainCol.classList.remove('lg:max-w-[56rem]');
                        mainCol.classList.add('max-w-4xl', 'mx-auto');
                    }
                    if (bodyWrapper.classList.contains('lg:flex-row')) {
                        bodyWrapper.classList.remove('lg:flex-row', 'justify-between');
                        bodyWrapper.classList.add('items-center', 'max-w-4xl', 'mx-auto');
                    }
                    
                    // Revert post-cover outer container sizing to standard centered layout
                    if (bodyWrapper.classList.contains('max-w-6xl')) {
                        bodyWrapper.classList.remove('max-w-6xl');
                        bodyWrapper.classList.add('max-w-4xl');
                    }
                    
                    // Revert post-narrow outer container sizing to standard narrow layout
                    if (bodyWrapper.classList.contains('max-w-5xl')) {
                        bodyWrapper.classList.remove('max-w-5xl');
                        bodyWrapper.classList.add('max-w-[42rem]');
                    }
                }
            }
        }
    });
})();
